/**
 * Created by Jie Gao on 05/24/2019.
 */

import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {DragonTribeGameAssets} from "../DragonTribeGameAssets";
import {DTReelSymbol} from "./DTReelSymbol";

export class DTReelSymbolL extends DTReelSymbol {

    private _displayScale:number;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    public updateBackground(symHeight:number,callFromAS:boolean=false):void {
        super.updateBackground(symHeight,callFromAS);
        this._symTop.visible = false;
        this._symSides.visible = false;
        this._symBottom.visible = false;
        const scale:number = MathHelper.roundToDecimals(symHeight / 127.5, 2);
        for(let stateName in this._stateAnimations) {
            const state = this._stateAnimations[stateName];
            if(state != null) {
                state.scale.set(scale, scale);
                state.anchor.y = 0.5;
            }
        }
        this._displayScale = scale;
        const texture:string = DragonTribeGameAssets.L_BG[Math.floor(510 / symHeight) - 2];
        this._symBackground.texture = GameResources.getTextures(texture)[0];
    }

    protected initState(stateConfig:ISymbolStateConfig):boolean {
        if(super.initState(stateConfig)) {
            this._stateAnimations[stateConfig.keyword]!.scale.set(this._displayScale, this._displayScale);
            return true;
        }

        return false;
    }
}